import { render, staticRenderFns } from "./VueTypedJs.vue?vue&type=template&id=50e3d6ce&"
import script from "./VueTypedJs.vue?vue&type=script&lang=js&"
export * from "./VueTypedJs.vue?vue&type=script&lang=js&"
import style0 from "./VueTypedJs.vue?vue&type=style&index=0&id=50e3d6ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports